module.exports = __webpack_public_path__ + "img/enemy_122_004.1202107f.png";